/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'directions': {
    width: 16,
    height: 16,
    viewBox: '0 0 21 24',
    data: '<path pid="0" d="M6.456 0a.81.81 0 0 0-.383.142L2.34 2.81a.801.801 0 0 0 0 1.308l3.733 2.667c.136.097.299.15.466.15h5.066v1.6H7.073a1.111 1.111 0 0 0-.084 0 .8.8 0 0 0-.716.8v5.332a.8.8 0 0 0 .8.8h4.532V22.4h-2.4a.802.802 0 1 0 0 1.6h6.4a.8.8 0 1 0 0-1.6h-2.4v-6.933h5.067c.167 0 .33-.052.466-.15l3.733-2.666a.801.801 0 0 0 0-1.308l-3.733-2.667a.803.803 0 0 0-.466-.142h-5.067v-1.6h4.533a.8.8 0 0 0 .8-.8V.802a.8.8 0 0 0-.8-.8H6.54a1.111 1.111 0 0 0-.083 0zm.342 1.6h10.14v3.734H6.806L4.189 3.467l2.609-1.866zm1.074 8.533h10.141L20.621 12l-2.616 1.866H7.872v-3.733z"/>'
  }
})
